import { connect } from 'react-redux';
import MinimizedFrame from '../../../frames/minimized';
import { MESSAGE_TYPE } from '../actions';
import './style.scss';

class ChatMinimizedFrame extends MinimizedFrame {
    constructor(props) {
        super(props);

        // this.genesys = props.genesys;
        this.API = props.API;
        this.badgeTimer = null;
        this.lastBadgeCount = undefined;
    }

    componentDidMount() {
        // super.componentDidMount();

        // this.genesys.startChat({...this.props.userdata, ...this.props.chat.registration}); // will do nothing if chat already started
        this.API.start({
            ...this.props.userdata,
            ...this.props.chat.registration
        }); // will do nothing if chat already started
    }

    componentWillUnmount() {
        // super.componentWillUnmount();

        if (this.badgeTimer) clearTimeout(this.badgeTimer);
        this.badgeTimer = null;
    }

    componentDidUpdate() {
        const currentBadgeCount = this.props.badgeCount;
        if (
            this.lastBadgeCount !== undefined &&
            this.lastBadgeCount !== currentBadgeCount
        ) {
            this.setState({ badgeClass: 'minimized-view--badge-flash' });

            if (this.badgeTimer) clearTimeout(this.badgeTimer);
            this.badgeTimer = setTimeout(() => {
                this.setState({ badgeClass: '' });
            }, 2000);
        }

        this.lastBadgeCount = currentBadgeCount;
    }
}

ChatMinimizedFrame.defaultProps = {
    badgeCount: null,
    delays: {
        showAfter: 0,
        hideAfter: 0
    }
};

const getUnreadMessages = messages => {
    return messages.filter(
        m =>
            m.from !== 'client' &&
            (m.isRead === undefined || m.isRead === false) &&
            m.type !== MESSAGE_TYPE.CUSTOMMESSAGE
    );
};

const getUnreadMessagesCount = messages => {
    const unread = getUnreadMessages(messages).length;
    return unread > 0 ? unread : null;
};

const mapStateToProps = state => {
    return {
        chat: state.chat,
        badgeCount: getUnreadMessagesCount(state.chat.messages),
        unreadMessages: getUnreadMessages(state.chat.messages)
    };
};

export default connect(mapStateToProps)(ChatMinimizedFrame);
